/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../ui/settings/settings.component';
import * as i2 from './scenario.component.ngfactory';
import * as i3 from '../../../ui/settings/scenario.component';
import * as i4 from './sim-control.component.ngfactory';
import * as i5 from '../../../ui/settings/sim-control.component';
import * as i6 from './sim-options.component.ngfactory';
import * as i7 from '../../../ui/settings/sim-options.component';
import * as i8 from './time-stepping.component.ngfactory';
import * as i9 from '../../../ui/settings/time-stepping.component';
import * as i10 from './rendering.component.ngfactory';
import * as i11 from '../../../ui/settings/rendering.component';
const styles_SettingsComponent:any[] = ([] as any[]);
export const RenderType_SettingsComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_SettingsComponent,data:{}});
export function View_SettingsComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{compSimControl:0}),i0.ɵqud(402653184,2,{compSimOptions:0}),
      i0.ɵqud(402653184,3,{compTimeStepping:0}),i0.ɵqud(402653184,4,{compRendering:0}),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),18,'div',[['class','settings-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          2,'websph-settings-scenario',([] as any[]),(null as any),[[(null as any),
              'changeScenarioNotify']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SettingsComponent = _v.component;
            if (('changeScenarioNotify' === en)) {
              const pd_0:any = ((<any>_co.onScenarioChanged($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_ScenarioComponent_0,i2.RenderType_ScenarioComponent)),i0.ɵdid(49152,
          [['scenario',4]],0,i3.ScenarioComponent,([] as any[]),(null as any),{changeScenarioNotify:'changeScenarioNotify'}),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵted((null as any),['\n\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-sim-control',
          ([] as any[]),(null as any),[[(null as any),'maxTimeNotify'],[(null as any),
              'startNotify'],[(null as any),'stopNotify'],[(null as any),'doStepsNotify'],
              [(null as any),'resetNotify']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SettingsComponent = _v.component;
            if (('maxTimeNotify' === en)) {
              const pd_0:any = ((<any>_co.onMaxTimeChanged($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('startNotify' === en)) {
              const pd_1:any = ((<any>_co.onStart()) !== false);
              ad = (pd_1 && ad);
            }
            if (('stopNotify' === en)) {
              const pd_2:any = ((<any>_co.onStop()) !== false);
              ad = (pd_2 && ad);
            }
            if (('doStepsNotify' === en)) {
              const pd_3:any = ((<any>_co.onDoSteps($event)) !== false);
              ad = (pd_3 && ad);
            }
            if (('resetNotify' === en)) {
              const pd_4:any = ((<any>_co.onReset($event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },i4.View_SimControlComponent_0,i4.RenderType_SimControlComponent)),i0.ɵdid(49152,
          [[1,4],['simControl',4]],0,i5.SimControlComponent,([] as any[]),(null as any),
          {maxTimeNotify:'maxTimeNotify',doStepsNotify:'doStepsNotify',resetNotify:'resetNotify',
              startNotify:'startNotify',stopNotify:'stopNotify'}),(_l()(),i0.ɵted((null as any),
          ['\n\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-sim-settings',
          ([] as any[]),(null as any),[[(null as any),'integratorNotify'],[(null as any),
              'smoothingLengthNotify'],[(null as any),'boundaryNotify']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SettingsComponent = _v.component;
            if (('integratorNotify' === en)) {
              const pd_0:any = ((<any>_co.onIntegratorChanged($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('smoothingLengthNotify' === en)) {
              const pd_1:any = ((<any>_co.onSmoothingLengthChanged($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('boundaryNotify' === en)) {
              const pd_2:any = ((<any>_co.onBoundaryChanged($event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i6.View_SimOptionsComponent_0,i6.RenderType_SimOptionsComponent)),i0.ɵdid(49152,
          [[2,4],['simOptions',4]],0,i7.SimOptionsComponent,([] as any[]),(null as any),
          {integratorNotify:'integratorNotify',smoothingLengthNotify:'smoothingLengthNotify',
              boundaryNotify:'boundaryNotify'}),(_l()(),i0.ɵted((null as any),['\n\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-time-stepping',
          ([] as any[]),(null as any),[[(null as any),'dtFixedNotify'],[(null as any),
              'dtLimitNotify'],[(null as any),'dtModeNotify']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SettingsComponent = _v.component;
            if (('dtFixedNotify' === en)) {
              const pd_0:any = ((<any>_co.onDtFixedChanged($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('dtLimitNotify' === en)) {
              const pd_1:any = ((<any>_co.onDtLimitChanged($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('dtModeNotify' === en)) {
              const pd_2:any = ((<any>_co.onDtModeChanged($event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i8.View_TimeSteppingComponent_0,i8.RenderType_TimeSteppingComponent)),
      i0.ɵdid(49152,[[3,4],['timeStepping',4]],0,i9.TimeSteppingComponent,([] as any[]),
          (null as any),{dtFixedNotify:'dtFixedNotify',dtModeNotify:'dtModeNotify',
              dtLimitNotify:'dtLimitNotify'}),(_l()(),i0.ɵted((null as any),['\n\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-rendering',
          ([] as any[]),(null as any),[[(null as any),'visuSmoothingLengthNotify'],
              [(null as any),'pSizeNotify']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SettingsComponent = _v.component;
            if (('visuSmoothingLengthNotify' === en)) {
              const pd_0:any = ((<any>_co.onVisuSmoothingLengthChanged($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('pSizeNotify' === en)) {
              const pd_1:any = ((<any>_co.onParticleSizeChanged($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i10.View_RenderingComponent_0,i10.RenderType_RenderingComponent)),i0.ɵdid(49152,
          [[4,4],['rendering',4]],0,i11.RenderingComponent,([] as any[]),(null as any),
          {visuSmoothingLengthNotify:'visuSmoothingLengthNotify',pSizeNotify:'pSizeNotify'}),
      (_l()(),i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵted((null as any),['\n'])),
      (_l()(),i0.ɵted((null as any),['\n']))],(null as any),(null as any));
}
export function View_SettingsComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings',
      ([] as any[]),(null as any),(null as any),(null as any),View_SettingsComponent_0,
      RenderType_SettingsComponent)),i0.ɵdid(49152,(null as any),0,i1.SettingsComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const SettingsComponentNgFactory:i0.ComponentFactory<i1.SettingsComponent> = i0.ɵccf('websph-settings',
    i1.SettingsComponent,View_SettingsComponent_Host_0,{controller:'controller'},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/$$_gendir/ui/settings/settings.component.ngfactory.ts